.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--tuna-spacing-2);
  margin-bottom: var(--tuna-spacing-4);
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-3xl);
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

/* Sentence case, per the spec's microcopy; the Button primitive defaults to uppercase. */
.button {
  text-transform: none;
}

.split {
  align-items: stretch;
}

.splitMain {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}

.splitChevron {
  min-width: 0;
  padding-inline: var(--tuna-spacing-1);
  border-start-start-radius: 0;
  border-end-start-radius: 0;
  border-inline-start: 1px solid color-mix(in oklch, var(--tuna-palette-primary-contrastText) 28%, transparent);
}
